import React, { createContext, useEffect, useState } from "react";
import { customFetch } from "../utils/api";
export const UserContext = createContext();

const localName = "UserToken";
const localJson = { token: false, userId: "" };
const apiUrl = process.env.REACT_APP_API_URL;

export const UserProvider = (props) => {
    const initialToken = (() => {
        const storedToken = localStorage.getItem(localName);
        if (storedToken && storedToken !== "null" && storedToken !== "") {
            try {
                return JSON.parse(storedToken);
            } catch (error) {
                console.error("Failed to parse token from localStorage:", error);
                return localJson;
            }
        }
        return localJson;
    })();

    const [token, setToken] = useState(initialToken);
    const [loading, setLoading] = useState(true); // Добавляем состояние загрузки
    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    useEffect(() => {
        const fetchUser = async () => {
            try {
                if (token && token.token) {
                    const response = await customFetch(
                        apiUrl + "/checkToken",
                        { method: "POST" }
                    );
                    if (!response.ok) {
                        setToken(localJson);
                    } else {
                        let data = await response.json();
                        if (data.invalidToken == false) {
                            const newData = token;
                            newData.token = true;
                            localStorage.setItem(localName, JSON.stringify(newData));
                        } else {
                            setToken(localJson)
                            localStorage.setItem(localName, JSON.stringify(localJson));
                        }
                    }
                }
            } catch (error) {
                console.log(error)
                setToken(localJson);
            } finally {
                setLoading(false); // В любом случае завершаем загрузку
            }
        };

        fetchUser();
    }, [token]);

    return (
        <UserContext.Provider value={[token, setToken, loading]}>
            {props.children}
        </UserContext.Provider>
    );
};